export default "__VITE_ASSET___lANmRwk__"